import React, { useEffect, useState } from 'react';
import { Table, Dropdown, Menu, Checkbox, Select, Button, Modal, message } from 'antd';
import { CloseCircleOutlined, EllipsisOutlined, InboxOutlined, UnorderedListOutlined } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import { partnerChangeHistoryData, remarkData } from '../helper/payoutdatasample';
import PartnerChangeHistory from '../PartnerChangeHistory';
import RemarksComponent from '../RemarksComponent';
import { InputNumber } from 'antd';
import Dragger from 'antd/lib/upload/Dragger';
import axios from 'axios';
import { getHoldPayoutReasonAction, getPayoutRecoveryReasonAction, getremaphystorydata, getRemarksLanSuccess } from '../../../redux/PayoutLanData/Action';
import { connect } from 'react-redux';
import { Form } from 'antd';
import useSession from '../../CustomLogout/useSession';
import { useParams } from 'react-router-dom';
import { Payout_Service } from '../../../redux/Url';
import { render } from '@testing-library/react';
import { Input } from 'antd';
import { Upload } from 'antd';
import { data } from '../../PricingManagement/helper/PricingdashboardData';
import { min } from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { Spin } from 'antd';


const { Option } = Select;

const LanlistWithPayout = (props) => {
  const {
    landataSource,
    partnerList,
    partnerId,
    getpartnerList,
    setLanDatasource,
    makerAction,
    checkerAction,
    recovry,
    remap,
    unhold,
    fileApprovalId,
    mAdjustment,
    setMakerAction,
    setCheckerAction,
    setFileApprovalId,
    handleRadioChange,
    radiostate,
    setRadioState,
    handleCheckboxChange,
    selectedCheckboxes,
    handelAddRemap,
    handelAddhold,
    fetchPaginatedData,
    handleAddRecoveryRemark,
    pagination,
    onPageChange,
    monthlyReportid,
    downloadAction,
    setDownloadAction,
    downloading,

  } = props;

  const [form] = Form.useForm();

  const [datasource, setDatasource] = useState([]);
  const [editableRow, setEditableRow] = useState(null);
  const [editableRowhold, setEditableRowHold] = useState(null);
  const [editableRowRecover, setEditableRowHRecover] = useState(null);
  const [recoverAmt, setRecoverAmt] = useState(null);
  const [resDataRM, setresDataRm] = useState([]);
  const [recovryoption, setRecovryoption] = useState(null);
  const [selectedPartner, setSelectedPartner] = useState('');
  const [existingpartnerId, setExistingpartnerId] = useState(partnerId);
  const [pmapremark, setPmapremark] = useState("");
  const [pholdremark, setPholdremark] = useState("")
  const [holdReason, setHoldReason] = useState(null)
  const [ispmapremarkVisble, setPmapremarkVisble] = useState(false);
  const [isholdPayoutVisble, setIsholdPayoutVisble] = useState(false);
  const [partnerChangeOpen, setPartnerChangeOpen] = useState(false);
  const [recoverModalVisible, setRecoverModalVisible] = useState(false);
  const [partnerChangeData, setPartnerChangeData] = useState([]);
  const [remarks, setRemarks] = useState(false);
  const [emailconfData, setEmailconfDataData] = useState({});
  const [holdReasonData, setHoldReasonData] = useState([]);
  const [recoveryReasonData, setRecoveryReasonData] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const handleSessionExpired = useSession();
  const [payoutFileList, setPayoutFileList] = useState([]); // State to manage file upload


  // const {monthlyReportid} = useParams();

  useEffect(() => {

    setDatasource(landataSource);

    setEditableRow(null);
    setSelectedPartner(null);
  }, [landataSource, radiostate]);



  const fetchHoldReaonsData = async () => {
    try {
      const getHoldData = await props.getHoldPayoutReasonAction({
        accessToken: props.accessToken
      })
      const data = await getHoldData;
      const errorCode = getHoldData?.response?.data?.error?.errorCode || getHoldData?.response?.status;
      if (errorCode === "403" && (getHoldData?.response?.data?.error?.errorCode || getHoldData?.response?.status)) {
        handleSessionExpired(); //Logout the user if session expired
        return;
      }
      setHoldReasonData(data || []);
      return data;
    }
    catch (error) {
      setHoldReasonData([]);
      return [];
    }
  }

  const fetchRecoveryReasonData = async () => {
    try {
      const getRecoveryData = await props.getPayoutRecoveryReasonAction({
        accessToken: props.accessToken
      })
      const data = await getRecoveryData;
      const errorCode = getRecoveryData?.response?.data?.error?.errorCode || getRecoveryData?.response?.status;
      if (errorCode && errorCode === "403" && (getRecoveryData?.response?.data?.error?.errorCode || getRecoveryData?.response?.status)) {
        handleSessionExpired(); //Logout the user if session expired
        return;
      }

      setRecoveryReasonData(data || []);
      return data;
    }
    catch (error) {
      setRecoveryReasonData([]);
      return [];
    }
  }

  const fechRemapdata = async (record) => {

    try {
      const resgetReampHdata = props.getremaphystorydata({
        accessToken: props.accessToken,
        lanNo: record.lanNo
      });

      const data = await resgetReampHdata;
      const errorCode = resgetReampHdata?.response?.data?.error?.errorCode || resgetReampHdata?.response?.status;
      if (errorCode && errorCode === "403" && (resgetReampHdata?.response?.data?.error?.errorCode || resgetReampHdata?.response?.status)) {
        handleSessionExpired(); //Logout the user if session expired
        return;
      }
      setPartnerChangeData(data || []);

    } catch (error) {
      console.error("Error fetching remap history data:", error);
      message.error("Failed to fetch remap history data");


    }

  }


  const downloadReport = async (format) => {
    try {
      const response = await fetch(
        // `http://localhost:8301/partner-payout-service/reports/payout-lan-report-export?lanTab=${radiostate}&reportId=${monthlyReportid}&partnerId=${partnerId}&format=${format}`,
        `${Payout_Service}/reports/payout-lan-report-export?lanTab=${radiostate}&reportId=${monthlyReportid}&partnerId=${partnerId}&format=${format}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + props.accessToken, // Use the access token from props
          },
        }
      );
      if (!response.ok) throw new Error('Network response was not ok');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = format === 'csv' ? 'report.csv' : 'report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      message.success('Successfully downloaded the report');
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error('Download failed:', error);
    }
  };

  const handleMenuClick = async (record, action) => {
    if (action === 'RemapPartner') {

      if (record.disbSeq > 1) {
        message.error("Partner Remap for Tranche Disbursement is restricted.");
        return 0
      }
      // await getpartnerList();
      setEditableRow(record.payoutId);
      setSelectedPartner(null);
      setPmapremark("");
      form.resetFields(); // Reset the form fields
      setPayoutFileList([]);

    }
    else if (action === 'HoldPayout') {
      setIsholdPayoutVisble(true);
      fetchHoldReaonsData();
      setHoldReason(null);
      setPholdremark("");
      setEditableRowHold(record);

    }
    else if (action === 'UnholdPayout') {
      setIsholdPayoutVisble(true);
      fetchHoldReaonsData();
      setHoldReason(null);
      setPholdremark("");
      setEditableRowHold(record);

    }
    else if (action === 'RecoverPayout') {
      setRecoverAmt('');
      setPmapremark('');
      setRecovryoption(null)
      setRecoverModalVisible(true);
      fetchRecoveryReasonData();
      setEditableRowHRecover(record);
    }
    else if (action === 'RemappingHistory') {
      fechRemapdata(record)
      setPartnerChangeOpen(true);
    }

  };

  const handlePartnerChange = (value, record) => {

    const partCheck = partnerList.find((data) => data.partnerFirmId === value)

    if (partnerId === partCheck.partnerFirmId) {
      message.error("You cannot remap to the same partner.");
      return 0;
    }

    // if (partCheck.pricingAdded === false) {
    //   message.error("Pricing is not set for the " + partCheck.partnerFirmName)
    //   return 0
    // }
    setSelectedPartner(value);
    setPmapremarkVisble(true);
    form.resetFields();
    setPayoutFileList([]);
    setPmapremark("");
    setExistingpartnerId(partnerId)
  };

  const handleCloseModalpmapremark = () => {
    setPmapremarkVisble(false);
    setPmapremark("");
    form.resetFields(); // Reset the form fields
    setPayoutFileList([]);

  }
  const handleCloseModalholdPaout = () => {
    setIsholdPayoutVisble(false);
    setPholdremark("");
    setHoldReason(null);
  }
  const handleCloseModalrecoverPaout = () => {
    setRecoverModalVisible(false);
    setPmapremark("");
    setRecovryoption(null);
    setRecoverAmt(null);
    form.resetFields(); // Reset the form fields
    setRecoverModalVisible(false);
    setRecoverAmt(null);
    setPmapremark("");
    setRecovryoption(null);

  }
  const handelsavePremark = () => {
    if (!pmapremark || !emailconfData.emailconfDataPath) {
      // Show an error message or notification to the user
      message.error("Remark and file attachment are mandatory.");
      setPayoutFileList([]);
      setPmapremark("")
      form.resetFields(""); // Reset the form fields
      return;
    }
    setPmapremarkVisble(false);
  };

  const formatRemarks = (remarks) => {

    const sortdata = remarks.sort((a, b) => {
      const dateA = new Date(a.createDateTime);
      const dateB = new Date(b.createDateTime);

      return dateA.getTime() - dateB.getTime(); // Newest first
    });

    return remarks
      ?.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
      .map((remarks) => (
        <div className='containerRemarks' style={{ display: 'block' }} key={remarks.lanRemarkId}>
          <div style={{ display: 'flex' }}>
            <b>{remarks.createdByName}</b>
            <b className='userRole' >({remarks.createdByRole})</b>
          </div>
          <div style={{ display: 'grid' }} className='commentContainer'>
            <span style={{ maxWidth: "200px" }}> {remarks.remarks} </span>
            <small>
              {new Date(remarks.createdDate).toLocaleString()}| Reason:{remarks.lanRemarkType}
            </small>
          </div>
        </div>
      ));
  };

  // var resData = formatRemarks(remarkData)
  // var resData;
  const fatechRemarLanLavel = async (record) => {

    const lanRemarkdata = await props.getLanRemarkData({
      accessToken: props.accessToken,
      payoutId: record.payoutId
    })


    return lanRemarkdata;


  }

  const handleRemarksModal = async (record, key) => {
    setIsLoading(key);

    const resData1 = await fatechRemarLanLavel(record)
    setIsLoading(null);

    const flatArray = Object.values(resData1).flat();

    const resData = formatRemarks(flatArray)

    setresDataRm(resData);
    if (resData.length > 0) {
      setRemarks(true)
    } else {
      setIsLoading(null);
      message.warning("No remarks found for this record.");

    }

  }



  const handelCancleRemap = () => {
    setEditableRow(null);
    setSelectedPartner(null);
    setPmapremark("");
    setExistingpartnerId(partnerId);
  };

  const handleSavePartnerChange = async (record) => {


    if (!pmapremark || !emailconfData?.emailconfDataPath) {
      message.error("You cannot remap without remark and attchement");
      setPmapremarkVisble(true);
      return 0;
    }

    if ((selectedPartner === null || selectedPartner === undefined || selectedPartner === '') || (partnerId === selectedPartner)) {
      message.error("You cannot remap to the same partner.");
      return 0;
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append("oldPartnerId", existingpartnerId);
    formData.append("newPartnerId", selectedPartner);
    formData.append("lanNo", record.lanNo);
    formData.append("payoutId", record.payoutId);
    formData.append("remarks", pmapremark);
    formData.append("file", emailconfData.emailconfDataPath); // If this is a file, use File object
    formData.append("remapStageId", 3);
    formData.append("userRole", props.userDetail.roleName);
    formData.append("createdBy", props.userDetail.userId);

    try {
      const res = await handelAddRemap(formData); // Ensure handelAddRemap handles FormData
      if (res.code === "ERR_NETWORK") {
        throw new Error("Network error");
      }
      setIsLoading(false);
      message.success("Partner remap request successfully added", 3);
      setEditableRow(null);
      await handleRadioChange("REMAP");
      form.resetFields(); // Reset the form fields
      setPayoutFileList([]);


      // Optionally reset fields here
      // setSelectedPartner(null);
      // setPmapremark(null);
    } catch (error) {
      setIsLoading(false);
      message.error(`Partner remap request error: ${error.message || error}`, 3);

    }

  };


  const handlePartnerHoldSave = async () => {
    if (unhold === false) {
      if (holdReason === null || holdReason === undefined) {
        message.error("Please select hold reason");
        return 0;
      }
    }
    const holdPayload = {
      remarks: pholdremark,
      payoutId: editableRowhold.payoutId,
      lanNo: editableRowhold.lanNo,
      holdStageId: unhold ? 7 : 3, // Pending with CET Checker
      holdReason: unhold ? 0 : holdReason,
      userRole: props.userDetail.roleName,
      createdBy: props.userDetail.userId
    };


    try {
      const resHoldAdd = await handelAddhold(holdPayload);
      if (resHoldAdd.code === "ERR_NETWORK") {
        throw new Error("Network error");
      }
      console.log("resHoldAdd", resHoldAdd);
      unhold ? message.success("Unhold request successfully added", 3) : message.success("Hold request successfully added", 3);
      setHoldReason(null);
      setPholdremark("");
      setIsholdPayoutVisble(false);
      unhold ? fetchPaginatedData("REGULAR") : fetchPaginatedData("ONHOLD");
    } catch (error) {
      message.error(`Hold request getting Error: ${error.message || error}`, 3);
    }
  };

  const handleTextAreaChange = (e) => {
    const value = e.target.value;
    if (value === '') {
      message.error("Please add remarks"); setPholdremark("");

    } else if (value !== pholdremark && value.length <= 250) {
      setPholdremark(value);
    } else {
      message.error("You can only enter a maximum of 250 characters.");
    }
  };

  const onChangehold = (value) => {
    setHoldReason(value)

  }
  const onChange = (value) => {
  };

  const onChangerecover = (value) => {
    if (value === 'Full Recovery') {
      setRecoverAmt(editableRowRecover?.debitAmount); // Reset recover amount for these options
      form.setFieldsValue({ recoverAmount: editableRowRecover?.debitAmount });
      setRecovryoption(value); // Set recovery option
    } else if (value === 'Partial Recovery') {

      setRecoverAmt(null); // Reset recover amount for these options
      form.setFieldsValue({ recoverAmount: null });
      setRecovryoption(value); // Set recovery option
    }
    else if (value === 'Waiver') {
      setRecoverAmt(0); // Reset recover amount for these options
      form.setFieldsValue({ recoverAmount: 0 });
      setRecovryoption(value); // Set recovery option
    }
  };

  const onSearch = (value) => {
  };


  const handleHeaderMenuClick = (key) => {
    switch (key) {
      case 'ExportCSV':
        downloadReport('csv');
        break;
      case 'ExportExcel':
        downloadReport('excel');
        break;
      case 'AddRemark':
        setRemarks(true);
        break;
      default:
    }
  };

  const handelRecoverysubmit = async () => {


    const recoveryOption2 = optionOfRecoveryReason.find(
      option => option.value === recovryoption
    )?.optionId || '';

    const recoverPayload = {
      remarks: pmapremark,
      payoutId: editableRowRecover.payoutId,
      recoveryStage: 3, // Approved 
      recoveryAmount: String(recoverAmt),
      recoveryOption: recoveryOption2,
      userRole: props.userDetail.roleName,
      createdBy: props.userDetail.userId

    };

    try {
      const resRemark = await handleAddRecoveryRemark(recoverPayload);
      if (resRemark.code === "ERR_NETWORK") {
        throw new Error("Network error");
      }
      message.success("Recovery request successfully added", 3);
      setPmapremark("");
      setRecovryoption(null);
      setRecoverAmt(null);
      setRecoverModalVisible(false);
      fetchPaginatedData("RECOVERY");
    } catch (error) {
      message.error(`Recovery request getting Error: ${error.message || error}`, 3);
    }


  }

  const handleFileChange = (info) => {
    if (info.file.status === 'done' || info.file.status === 'uploading' || info.file.status === 'error') {
      setEmailconfDataData((prev) => ({ ...prev, emailconfDataPath: info.file.originFileObj }));
    }
    // if (info.file.status === 'done') {
    //   // setEmailconfDataData({...emailconfData, emailconfDataPath: info.file.originFileObj})
    //   setEmailconfDataData((prev) => ({ ...prev, emailconfDataPath: info.file.originFileObj }));
    //   console.log("success")
    // } else if (info.file.status === 'error') {
    //   setEmailconfDataData((prev) => ({ ...prev, emailconfDataPath: info.file.originFileObj }));
    //   console.log("error in uploading")
    // }
  }



  // const uploadProps = {
  //   name: 'file',
  //   multiple: false,
  //   accept: '.pdf',
  //   beforeUpload: (file) => {
  //     const isPDF = file.type === 'application/pdf';
  //     if (!isPDF) {
  //       console.log(`${file.name} is not a PDF`)
  //     }
  //     return isPDF;
  //   },
  //   onChange: handleFileChange
  // }

  const removeFileFromList = () => {
    setPayoutFileList([]);
  }

  const uploadProps = {
    name: 'file',
    multiple: false,
    accept: '.pdf',
    showUploadList: {
      showPreviewIcon: false,
      showRemoveIcon: true,
      showDownloadIcon: false,
      removeIcon: <span>✖</span>
    },
    fileList: payoutFileList,
    customRequest: async ({ file, onSuccess, onError }) => {
      try {
        onSuccess("ok");
      } catch (err) {
        onError("Upload failed. Please try again.");
        message.error('Upload failed. Please try again.');
      }
    },
    beforeUpload: (file) => {
      // Check if a file is already present
      if (payoutFileList && payoutFileList.length > 0) {
        message.error('You can only upload one file.');
        setPayoutFileList([]);
        return Upload.LIST_IGNORE;
      }

      const isPDF = file.type === 'application/pdf' && file.name.toLowerCase().endsWith('.pdf');
      if (!isPDF) {
        message.error('Only PDF documents are allowed.');
        setPayoutFileList([]);
        return Upload.LIST_IGNORE;
      }
      const isLt250KB = 5 * 1024  * 1024;
      if (file.size >= isLt250KB) {
        message.error('File must be smaller than 5MB.');
        setPayoutFileList([]);
        return Upload.LIST_IGNORE;
      }
      message.success('File is attached succesfully.');
      return true;
    },
    onRemove: () => {
      setEmailconfDataData((prev) => ({ ...prev, emailconfDataPath: null }));
      setPayoutFileList([]);
      removeFileFromList();
    },
    onChange: (info) => {
      // Only update file list if the file is valid
      const validFiles = info.fileList.filter(f =>
        f.type === 'application/pdf' &&
        f.name.toLowerCase().endsWith('.pdf') &&
        f.size <= 5 * 1024  * 1024
      );
      setPayoutFileList(validFiles);
      handleFileChange(info);

    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    if (value.length <= 250) {
      setPmapremark(value);
    } else {
      message.error("You can only enter a maximum of 250 characters.");
    }
  }

  const headerMenu = (
    <Menu
      onClick={({ key }) => handleHeaderMenuClick(key)}
      items={[
        { label: 'Export to CSV', key: 'ExportCSV' },
        { label: 'Export to Excel', key: 'ExportExcel' },
        // { label: 'Hold Payout(Bulk Action)', key: 'HoldPayoutBulk' },
        // { label: 'Add/ View Remark(Partner)', key: 'AddRemark' },
      ]}
    />
  );

  // const optionOfReasion =[
  //   {
  //     value: 'OTC Document Pending',
  //     label: 'OTC Document Pending',
  //   },
  //   {
  //     value: 'GST Number Missing',
  //     label: 'GST Number Missing',
  //   },
  //   {
  //     value: 'Agreement Expired',
  //     label: 'Agreement Expired',
  //   },
  // ]

  const optionOfReasion = holdReasonData.map(data => ({
    value: data.holdReasonId,
    label: data.reason,
  }));


  const optionOfRecoveryReason = recoveryReasonData.map(data => ({
    value: data.recoveryOption,
    label: data.recoveryOption,
    optionId: data.recoveryOptionId,
  }));



  const columns = [
    // ...(makerAction && checkerAction
    //   ? [
    //       {
    //         title: 'Check',
    //         dataIndex: 'Check',
    //         key: 'Check',
    //         fixed: 'left',
    //         width: 60,
    //         render: (_, record) => (
    //           <Checkbox
    //             checked={selectedCheckboxes.Check.includes(record)}
    //             onChange={(e) => handleCheckboxChange(e, 'Check', record)}
    //           />
    //         ),
    //       },
    //     ]
    //   : []),
    {
      title: 'Applicant Name',
      dataIndex: 'applicantName',
      key: 'applicantName',
      align: 'center',
      width: 200,
    },
    {
      title: 'Dibursement File No',
      dataIndex: 'lanNo',
      key: 'lanNo',
      align: 'center',
      width: 190,
    },
    {
      title: 'Disbursal Date',
      dataIndex: 'disbDate',
      key: 'disbDate',
      align: 'center',
      width: 190,
    },
    editableRow ? {
      title: 'Partner Name',
      dataIndex: 'partnerName',
      key: 'partnerName',
      align: 'center',
      fixed: 'left',
      width: 200,
      render: (text, record) => {

        return editableRow === record.payoutId ? (
          <Select
            value={selectedPartner || record.partnerId}
            onChange={(value) => {
              handlePartnerChange(value, record)
            }}
            showSearch
            placeholder="Select Partner"
            style={{ width: '100%', minWidth: '200px' }}
            optionFilterProp="children"
          >
            {partnerList?.map((partner) => (
              <Option style={{ color: partner.pricingAdded ? "black" : "red" }} key={partner.partnerFirmId} value={partner.partnerFirmId}>
                {partner.partnerFirmName}
              </Option>
            ))}
          </Select>
        ) : (
          text
        );
      }
    } : {
      title: 'Partner Name',
      dataIndex: 'partnerName',
      key: 'partnerName',
      align: 'center',
      width: 200,
      render: (text, record) => {

        return editableRow === record.payoutId ? (
          <Select
            value={selectedPartner || record.partnerId}
            onChange={(value) => {
              handlePartnerChange(value, record)
            }}
            showSearch
            placeholder="Select Partner"
            style={{ width: '100%', minWidth: '200px' }}
            optionFilterProp="children"
          >
            {partnerList?.map((partner) => (
              <Option style={{ color: partner.pricingAdded ? "black" : "red" }} key={partner.partnerFirmId} value={partner.partnerFirmId}>
                {partner.partnerFirmName}
              </Option>
            ))}
          </Select>
        ) : (
          text
        );
      }
    },
    {
      title: 'Partner Code',
      dataIndex: 'partnerCode',
      key: 'partnerCode',
      align: 'center',
      width: 190,
    },
    {
      title: '1st Disb Amount',
      dataIndex: 'firstDisbAmount',
      key: 'firstDisbAmount',
      align: 'center',
      width: 190,
      render: (_, amount) => amount.disbSeq > 1 ? 0 : amount.firstDisbAmount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Tranche Disb Amount',
      dataIndex: 'disbAmount',
      key: 'disbAmount',
      align: 'center',
      width: 190,
      render: (_, record) => (record.disbSeq > 1 ? record.disbAmount : 0
      ).toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Disb Cumulative',
      dataIndex: 'cumulativeAmount',
      key: 'cumulativeAmount',
      align: 'center',
      width: 190,
      render: (_, record) => {
        const cumulative = record.cumulativeAmount || 0;
        return cumulative.toLocaleString("en-IN", { style: "currency", currency: "INR" });
      }
    },
    {
      title: 'Payout Status',
      dataIndex: 'transactionStatus',
      key: 'transactionStatus',
      align: 'center',
      width: 190,
      render: (_, record) => {
        if (record.onHold === 3)
          return "On-Hold Requested";
        else if (record.onHold === 7)
          return "UnHold Requested";
        else if (record.remapStageId === 3)
          return "Remap Requested";
        else
          return record.transactionStatus;
      },
    },
    {
      title: 'Credit Amount',
      dataIndex: 'creditAmount',
      key: 'creditAmount',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Debit Amount',
      dataIndex: 'debitAmount',
      key: 'debitAmount',
      align: 'center',
      width: 190,
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Percentage Applied',
      dataIndex: 'percentage',
      key: 'percentage',
      align: 'center',
      width: 100,
      render: (value) => value !== undefined && value !== null ? `${value}%` : '-',
    },
    // {
    //   title: 'Status Amount',
    //   dataIndex: 'regular',
    //   key: 'regular',
    //   align:'center',
    // },
    {
      title: 'Remark',
      dataIndex: 'Remark',
      key: 'Remark',
      render: (_, record, key) => (
        <Button loading={isLoading === key} className='remarkView-btn' style={{ border: "none", color: "#000", fontSize: "14px" }} onClick={() => handleRemarksModal(record, key)} >
          Remark
        </Button>
      )
    },
    ...(recovry
      ? [
        {
          title: 'Recovery Final Amount',
          dataIndex: 'finaRecoveryAmount',
          key: 'finaRecoveryAmount',
          align: 'center',
          width: 170,
          render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
        },
      ]
      : []
    ),
    ...(makerAction && checkerAction || recovry || remap || unhold || downloadAction
      ? [
        {
          title: (
            downloadAction ? (
              <Dropdown overlay={headerMenu} trigger={['click']}>
                <span style={{ cursor: 'pointer' }}>
                  Action <EllipsisOutlined />
                </span>
              </Dropdown>
            ) : (
              <span style={{ cursor: 'not-allowed', color: '#ccc' }}>
                Action <EllipsisOutlined />
              </span>
            )
          ),
          dataIndex: 'Action',
          key: 'Action',
          fixed: 'right',
          align: 'center',
          width: 100,
          render: (_, record) => {

            if (downloadAction) {
              return (
                <span style={{ color: '#ccc', cursor: 'not-allowed', fontSize: '18px' }}>
                  <UnorderedListOutlined />
                </span>
              );
            }

            const menuItems = recovry ? fileApprovalId > 1 ? [] : [{ label: 'Recover Payout', key: 'RecoverPayout' }] :
              remap ? [
                { label: 'Remapping History', key: 'RemappingHistory' },
                fileApprovalId > 1 || record.remapStageId <= 3 ? [] :
                  { label: 'Remap Partner', key: 'RemapPartner' },
              ] :
                unhold ? fileApprovalId > 1 ? [] : [
                  { label: 'Unhold Payout', key: 'UnholdPayout' }
                ] : fileApprovalId > 1 ? []
                  :
                  [
                    { label: 'Remap Partner', key: 'RemapPartner' },
                    { label: 'Hold Payout', key: 'HoldPayout' },
                    // { label: 'Recover Payout', key: 'RecoverPayout' },

                  ];
            const menu = (
              <Menu
                onClick={({ key }) => handleMenuClick(record, key)}
                items={menuItems}
              />
            );

            return (
              <>
                <Dropdown overlay={menu} trigger={['click']}>
                  <UnorderedListOutlined
                    style={{ cursor: 'pointer', fontSize: '18px' }}
                  />
                </Dropdown>
                {editableRow === record.payoutId && (
                  <>
                    <Button
                      className="ant-btn ant-btn-default"
                      style={{
                        fontSize: '0.7rem',
                        backgroundColor: '#1b8593',
                        color: '#fff',
                        margin: '3px',
                        borderRadius: '5px',
                      }}
                      onClick={() => handleSavePartnerChange(record)}
                      loading={isLoading}
                    >
                      Save
                    </Button>
                    <span style={{ color: "#1b8593", fontSize: "0.8rem" }}>
                      <CloseCircleOutlined onClick={handelCancleRemap} />
                    </span>
                  </>
                )}
              </>
            );
          },
        },
      ]
      : []),
  ];





  return (
    <div style={{ maxWidth: '100%' }}>
      {downloading && (
        <div style={{
          position: 'absolute',
          zIndex: 10,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(255,255,255,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Spin tip="Loading..." size="large" />
        </div>
      )}
      <Table dataSource={datasource}

        pagination={pagination}
        showSizeChanger={true}

        onChange={(pagination) => {
          // Call the parent's handler if provided
          if (props.onPageChange) {
            props.onPageChange(pagination.current, pagination.pageSize, radiostate);
          }
        }} columns={columns} rowKey={(record, index) => index} scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }} />
      <Modal
        title="Add Remark"
        visible={ispmapremarkVisble}
        onCancel={handleCloseModalpmapremark}
        footer={null}
      >
        <Form form={form}>
          <Form.Item
            name="pmapremark"
            required
            rules={[{ required: true, message: 'Please add Query Remark' },
            {
              validator: (_, value) => {
                if (value && value.split(/\s+/).filter(Boolean).length > 250) {
                  return Promise.reject('Remark cannot exceed 250 words');
                }
                return Promise.resolve();
              }
            }]}
          >
            <TextArea
              placeholder="Please add comment to submit"
              onChange={(e) => handleChange(e)}
              autoSize={{ minRows: 2, maxRows: 6 }}
              value={pmapremark}
              maxLength={250}
              showCount={true}
            />
          </Form.Item>
          <Form.Item>

            <Dragger {...uploadProps} style={{ marginTop: "0.3rem", marginBottom: "0.3rem" }}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
            </Dragger>
          </Form.Item>
          <Form.Item>
            <Button
              disabled={pmapremark === null}
              type="link"
              onClick={() => handelsavePremark()}
              style={{ background: "#1b8593", marginTop: "0.3rem", color: "#fff" }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>

      </Modal>

      <Modal
        title={unhold === false ? "Hold Payout" : "Unhold Payout"}
        visible={isholdPayoutVisble}
        onCancel={handleCloseModalholdPaout}
        footer={null}
      >

        {(unhold === false) && (<Select
          showSearch
          placeholder="Select Hold Reason"
          optionFilterProp="label"
          onChange={onChangehold}
          onSearch={onSearch}
          style={{ width: '100%', marginTop: "0.3rem", marginBottom: "0.3rem" }}
          options={optionOfReasion}
        />)
        }
        <TextArea
          placeholder="Please add comment to submit"
          name="holdremarktext"
          value={pholdremark}
          onChange={handleTextAreaChange}
          autoSize={{ minRows: 2, maxRows: 6 }}
          maxLength={250}
          showCount={true}
        />
        <Button
          disabled={!pholdremark || pholdremark.trim() === ""}
          type="link"
          onClick={handlePartnerHoldSave}
          style={{ background: "#1b8593", marginTop: "0.3rem", color: "#fff" }}
        >
          Confirm
        </Button>
      </Modal>


      <Modal
        title="Recover Payout"
        visible={recoverModalVisible}
        onCancel={handleCloseModalrecoverPaout}
        footer={null}
      >
        <Form
          form={form}
        >
          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <Form.Item
              name="recoverOption"
              rules={[{ required: true, message: 'Please select a recovery option' }]}
              style={{ flex: 1 }}
            >

              <Select
                showSearch
                placeholder="Select Recover Reason"
                optionFilterProp="label"
                onChange={onChangerecover}
                onSearch={onSearch}
                style={{ flex: 1 }}
                options={optionOfRecoveryReason}
              />
            </Form.Item>
            <Form.Item
              name="recoverAmount"
              rules={[{ required: true, message: 'Please enter a recovery amount' }]}
              style={{ flex: 1 }}
            >
              <InputNumber
                placeholder="Enter Amount"
                style={{ flex: 1, minWidth: '100%' }}
                max={editableRowRecover?.debitAmount}
                min={0}
                value={recoverAmt}
                onChange={(value) => {
                  const max = editableRowRecover?.debitAmount ?? Infinity;
                  if (value > max) {
                    message.error(`Amount cannot exceed ${max}`);
                    setRecoverAmt(max);
                  } else {
                    setRecoverAmt(value);
                  }
                }}
                disabled={
                  (recovryoption === 'Full Recovery' || recovryoption === 'Waiver')
                    ? recoverAmt === editableRowRecover?.debitAmount || recoverAmt === 0
                    : false
                }
              />
            </Form.Item>
          </div>
          <Form.Item
            name="pmapremark"
            rules={[{ required: true, message: 'Please add a comment' }]}
          >
            <TextArea
              placeholder="Please add comment to submit"
              onChange={(e) => setPmapremark(e.target.value)}
              autoSize={{ minRows: 2, maxRows: 6 }}
              style={{ width: '100%', marginBottom: '0.5rem' }}
            />
          </Form.Item>
          <Form.Item>
            <Button
              disabled={!pmapremark}
              type="link"
              loading={isLoading}
              onClick={handelRecoverysubmit}
              style={{ background: "#1b8593", color: "#fff", width: '100%' }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <PartnerChangeHistory
        partnerChangeData={partnerChangeData}
        setPartnerChangeData={setPartnerChangeData}
        partnerChangeOpen={partnerChangeOpen}
        setPartnerChangeOpen={setPartnerChangeOpen}
      // resData = {resData}
      />
      <RemarksComponent
        resData={resDataRM}
        remarks={remarks}
        setRemarks={setRemarks}
        isHistory={true}
      />
    </div>
  );
};



const mapDispatchToProps = (dispatch) => {
  return {
    getHoldPayoutReasonAction: (data) => dispatch(getHoldPayoutReasonAction(data)),
    getPayoutRecoveryReasonAction: (data) => dispatch(getPayoutRecoveryReasonAction(data)),
    getremaphystorydata: data => dispatch(getremaphystorydata(data)),
    getLanRemarkData: data => dispatch(getRemarksLanSuccess(data))
  }
}

const mapStateToProps = (state) => {
  return {
    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LanlistWithPayout);